// Tầng công pháp chủ tu (CULTIVATION §6.1, BALANCE §2.4). Lên tầng là hành động bấm tay:
// cần Tâm Đắc + linh thạch, không vượt trần tầng của cảnh giới hiện tại.
import { BALANCE } from '@data/balance';
import { TECHNIQUE_MAX_LAYER } from '@data/content/techniques';
import { stepInfo } from './steps';
import type { CultivationState } from './types';

export interface LayerCost {
  mastery: number;
  stones: number;
}

/** Giá để lên tầng `toLayer` (2..9). */
export function layerCost(toLayer: number): LayerCost {
  return {
    mastery: BALANCE.TECHNIQUE_LAYER_MASTERY_COST[toLayer - 1] ?? Infinity,
    stones: BALANCE.TECHNIQUE_LAYER_STONE_COST[toLayer - 1] ?? Infinity,
  };
}

export function layerCap(state: CultivationState): number {
  const cap = BALANCE.TECHNIQUE_LAYER_CAP_BY_REALM[stepInfo(state.step).realmIdx] ?? TECHNIQUE_MAX_LAYER;
  return Math.min(cap, TECHNIQUE_MAX_LAYER);
}

export type LayerBlock = 'maxLayer' | 'realmCap' | 'mastery' | 'stones';

export function layerBlock(state: CultivationState, stones: number): LayerBlock | null {
  const next = state.technique.layer + 1;
  if (next > TECHNIQUE_MAX_LAYER) return 'maxLayer';
  if (next > layerCap(state)) return 'realmCap';
  const c = layerCost(next);
  if (state.technique.mastery < c.mastery) return 'mastery';
  if (stones < c.stones) return 'stones';
  return null;
}

/** Lên một tầng; trả state mới và số linh thạch phải trừ (lớp state trừ ví). */
export function raiseTechniqueLayer(
  state: CultivationState,
  stones: number,
): { state: CultivationState; stonesSpent: number } {
  const block = layerBlock(state, stones);
  if (block) throw new Error(`cannot raise technique layer: ${block}`);
  const next = state.technique.layer + 1;
  const c = layerCost(next);
  return {
    state: {
      ...state,
      technique: { ...state.technique, layer: next, mastery: state.technique.mastery - c.mastery },
    },
    stonesSpent: c.stones,
  };
}
